import '../lib/owl.carousel2';

/*
NOTE: We have implemented the temporary fix in here:
https://github.com/OwlCarousel2/OwlCarousel2/issues/1771
If we lose that change we may need to remove the mouse drag (mouseDrag: false)
*/

export default class TrainingModule {

    constructor() {
        const self = this;

        this.desktopBreakpoint = 1026;     
        this.blockWrapper = $('.training-slides');

        this.blockWrapper.each(function() {
            $(this).on('initialized.owl.carousel', function() { 
                const container = $(this).closest('.training-container');
                self.enableDisableNavButtons(container);
            });

            $(this).owlCarousel({
                dots: false,
                nav: false,
                autoWidth: true,
                onTranslated: function(me) {
                    const container = $(me.target).closest('.training-container');
                    self.enableDisableNavButtons(container);
                }
            });
        });

        this.setClickEvents();
        this.setScrollEvent();

        $(window).on('resize', () => {
            self.reIntialise();
        });

        $('.roletype-toggle-checkbox').on('change', () => {
            setTimeout(() => {
                const $visibleContainer = $('.training-container:visible');
                const $visibleCarousel = $visibleContainer.find('.training-slides');
                $visibleCarousel.trigger('refresh.owl.carousel');

                if (self.cardsInView($visibleContainer)) {
                    $visibleContainer.find('.training-slide-wrapper').addClass('hover');
                }
            }, 100);
        });
    }

    setClickEvents() {
        const self = this;

        $(document).on('click', '.training-slide-wrapper', function(e) {       
            self.slideWrapperClick($(this));
        });

        $(document).on('click', '.owl-prev-custom', function() {
            self.prev($(this));
        });

        $(document).on('click', '.owl-next-custom', function() {
            self.next($(this));
        });
    }

    setScrollEvent() {
        const self = this;

        $('.training-container:visible').each(function() {
            if (self.cardsInView($(this))) {
                $(this).find('.training-slide-wrapper').addClass('hover');
            }
        });

        $(window).on('resize scroll', function() {
            $('.training-container:visible').each(function() {
                if (self.cardsInView($(this))) {
                    $(this).find('.training-slide-wrapper').addClass('hover');
                }
            });
        });        
    }

    cardsInView(container) {
        if (!container || !container.is(':visible')) 
            return false;

        const winTop = $(window).scrollTop();
        const winBottom = winTop + $(window).height();

        const elTop = container.offset().top;
        const elBottom = elTop + container.outerHeight();

        return elBottom > winTop && elTop < winBottom;
    }

    slideWrapperClick(slideWrapper) {
        const container = slideWrapper.closest('.training-container');
        const navBlock = container.find('.owl-nav-custom');
        const slide = slideWrapper.closest('.training-slide'); 

        navBlock.find('.training-slide-moredetails-wrapper').remove();           
        container.find('.training-slide-downmarker').hide();    

        if (slideWrapper.hasClass('open')) {
            slideWrapper.removeClass('open');
            this.openSlideId = 0;
            this.openSlide = slide;
            navBlock.find('.owl-nav-custom-buttonwrapper').removeClass('pull-right');
            this.enableDisableNavButtons(container);
        } else {
            container.find('.training-slide-wrapper').removeClass('open');
            slideWrapper.addClass('open');
            this.showHideReadmore(slide);            
        }  
    }

    showHideReadmore(slide) {
        const downmarker = slide.find('.training-slide-downmarker');          
        const container = slide.closest('.training-container');        
        const navBlock = container.find('.owl-nav-custom');

        this.openSlideId = slide.data('slideid');
        this.openSlide = slide;

        container.find('.training-slide-downmarker').hide();  

        const readMoreBlock = navBlock.find('.training-slide-moredetails-wrapper');

        if (readMoreBlock.length > 1) {
            navBlock.find('.training-slide-moredetails-wrapper').animate({
                'margin-left': -5000, 
                'margin-right': 5000, 
                'width': 0, 
                'height': 0
            }, 300);
            navBlock.find('.owl-nav-custom-buttonwrapper').removeClass('pull-right');
        } else {
            navBlock.find('.training-slide-moredetails-wrapper').remove();
            navBlock.prepend(slide.find('.training-slide-moredetails').html());
            navBlock.append(slide.find('.training-slide-moredetails').html());
            navBlock.find('.owl-nav-custom-buttonwrapper').addClass('pull-right');
            navBlock.find('.training-slide-moredetails-wrapper').animate({
                'margin-left': 0, 
                'margin-right': 0
            }, 600);
            downmarker.show();
        }

        this.enableDisableNavButtons(container);
    }

    prev(button) {
        if ($(this).hasClass('disabled')) 
            return;
        if (window.innerWidth < this.desktopBreakpoint) { 
            this.prevMobile(button);
        } else {
            this.prevDesktop(button);
        }        
    }

    next(button) {
        if ($(this).hasClass('disabled')) 
            return;
        if (window.innerWidth < this.desktopBreakpoint) { 
            this.nextMobile(button);
        } else {
            this.nextDesktop(button);
        }          
    }

    prevDesktop(button) {
        const container = button.closest('.training-container');
        const openSlideId = container.find('.owl-nav-custom .training-slide-moredetails-wrapper').data('slideid');

        container.find('.training-slides').trigger('prev.owl.carousel');

        if (openSlideId > 1) {
            const prevSlide = container.find(`.training-slide[data-slideid="${openSlideId - 1}"]`);
            const slideWrapper = prevSlide.find('.training-slide-wrapper');      
            this.slideWrapperClick(slideWrapper);     
        } else {
            this.enableDisableNavButtons(container);
        }
    }

    prevMobile(button) {
        const container = button.closest('.training-container');
        const openSlideId = container.find('.owl-nav-custom .training-slide-moredetails-wrapper').data('slideid');

        container.find('.training-slides').trigger('prev.owl.carousel');

        if (openSlideId > 1) {
            const prevSlide = container.find(`.training-slide[data-slideid="${openSlideId - 1}"]`);
            const slideWrapper = prevSlide.find('.training-slide-wrapper');      
            const slide = slideWrapper.closest('.training-slide');  
            const readMoreButton = slide.find('.training-slide-readmore');
            this.slideWrapperClick(slideWrapper);
            this.readMoreClickMobile(readMoreButton);
        } 

        this.enableDisableNavButtons(container);
    }

    nextDesktop(button) {
        const container = button.closest('.training-container');
        const totalSlides = container.data('totalslides'); 
        const openSlideId = container.find('.owl-nav-custom .training-slide-moredetails-wrapper').data('slideid');

        container.find('.training-slides').trigger('next.owl.carousel');

        if (openSlideId !== undefined && openSlideId < totalSlides) {                               
            const nextSlide = container.find(`.training-slide[data-slideid="${openSlideId + 1}"]`);
            const slideWrapper = nextSlide.find('.training-slide-wrapper');      
            this.slideWrapperClick(slideWrapper);     
        } else {
            this.enableDisableNavButtons(container);
        }
    }

    nextMobile(button) {
        const container = button.closest('.training-container');
        const totalSlides = container.data('totalslides'); 
        const openSlideId = container.find('.owl-nav-custom .training-slide-moredetails-wrapper').data('slideid');

        container.find('.training-slides').trigger('next.owl.carousel');

        if (openSlideId !== undefined && openSlideId < totalSlides) {                               
            const nextSlide = container.find(`.training-slide[data-slideid="${openSlideId + 1}"]`);
            const slideWrapper = nextSlide.find('.training-slide-wrapper');      
            const slide = slideWrapper.closest('.training-slide');            
            const readMoreButton = slide.find('.training-slide-readmore');
            this.slideWrapperClick(slideWrapper);
            this.readMoreClickMobile(readMoreButton);
        } 

        this.enableDisableNavButtons(container);
    }

    enableDisableNavButtons(container) {        
        const cardCount = container.data('totalslides');
        const openCard = container.find('.owl-nav-custom .training-slide-moredetails-wrapper').data('slideid');
        const prevButton = container.find('.owl-prev-custom');
        const nextButton = container.find('.owl-next-custom');

        prevButton.removeClass('disabled');  
        nextButton.removeClass('disabled'); 

        if (openCard !== undefined) {
            if (openCard === 1) {
                prevButton.addClass('disabled');                        
            } else if (openCard === cardCount) {
                nextButton.addClass('disabled'); 
            }
        } else {                
            const containerWidth = container.width();     
            const owlStage = container.find('.owl-stage');
            const owlWidth = parseFloat(owlStage.css('width'), 10);
            const owlStageTransform = owlStage.css('transform');
            const translateX = owlStageTransform === 'none' || owlStageTransform === undefined 
                               ? 0 
                               : -1 * owlStage.css('transform').split(/[()]/)[1].split(',')[4];

            if (translateX === 0) 
                prevButton.addClass('disabled');
            if (owlWidth - translateX <= containerWidth) 
                nextButton.addClass('disabled');
        }
    }

    reIntialise() {
        const self = this;
        $('.training-container').each(function() {
            $(this).find('.open').removeClass('open');
            $(this).find('.training-slide-downmarker').hide();
            $(this).find('.owl-nav-custom-buttonwrapper').removeClass('pull-right');
            $(this).find('.owl-nav-custom .training-slide-moredetails-wrapper').remove();
            self.enableDisableNavButtons($(this));
        });
    }
}
